// extracted by mini-css-extract-plugin
export var backgroundNewLayout = "style-mod--background-new-layout--8ee4a";
export var badgeContainer = "style-mod--badge-container--d22c0";
export var badgeIcon = "style-mod--badge-icon--92449";
export var cardButton = "style-mod--card-button--b5f4b";
export var cardButtonNewLayout = "style-mod--card-button-new-layout--43ede";
export var clipStar = "style-mod--clip-star--9f6c2";
export var contentBox = "style-mod--content-box--097b4";
export var countingBar = "style-mod--countingBar--e2f15";
export var customersText = "style-mod--customers-text--5fc81";
export var descriptionBox = "style-mod--description-box--f545c";
export var desktopImg = "style-mod--desktop-img--8b084";
export var imageOverlay = "style-mod--image-overlay--dddba";
export var innerContainer = "style-mod--inner-container--50701";
export var innerNewLayout = "style-mod--inner-new-layout--d9177";
export var landingDescriptionBox = "style-mod--landing-description-box--a4dfa";
export var logo = "style-mod--logo--051da";
export var mobileContent = "style-mod--mobile-content--95c64";
export var mobileHalfImg = "style-mod--mobile-half-img--9142f";
export var mobileImg = "style-mod--mobile-img--9dad5";
export var newHeroSectionBox = "style-mod--new-hero-section-box--c4c2c";
export var newHeroSectionSlider = "style-mod--new-hero-section-slider--1cf0f";
export var newHeroSectionSlides = "style-mod--new-hero-section-slides--cfb5f";
export var notFullWidthSlider = "style-mod--not-full-width-slider--3a0c5";
export var optionalTitle = "style-mod--optional-title--92823";
export var slideBox = "style-mod--slide-box--ecee9";
export var slideContent = "style-mod--slide-content--67bef";
export var slideContentPosition = "style-mod--slide-content-position--fe427";
export var starWrapper = "style-mod--star-wrapper--d3c0c";
export var swiperContentOverlay = "style-mod--swiper-content-overlay--ef1be";
export var title = "style-mod--title--f52b3";
export var uspBox = "style-mod--usp-box--43699";